/**
 * Logged-in preview of the public landing page without signing out.
 * Common portal pattern: account menu → public site, with an explicit query so `/`
 * still redirects signed-in users to the app by default.
 */

export const PUBLIC_SITE_VIEW_PARAM = 'view';
export const PUBLIC_SITE_VIEW_VALUE = 'public';

/** Path used from the signed-in account menu. */
export const PUBLIC_SITE_PATH = `/?${PUBLIC_SITE_VIEW_PARAM}=${PUBLIC_SITE_VIEW_VALUE}`;

export function isPublicSiteViewSearch(search: string): boolean {
  const raw = search.startsWith('?') ? search.slice(1) : search;
  return new URLSearchParams(raw).get(PUBLIC_SITE_VIEW_PARAM) === PUBLIC_SITE_VIEW_VALUE;
}

/**
 * Keep `?view=public` on landing links so a signed-in preview is not
 * redirected into the app when they open About, Contact, and the other sections.
 */
export function withPublicSiteView(path: string, viewingPublicSite: boolean): string {
  if (!viewingPublicSite) return path;
  const hashIndex = path.indexOf('#');
  const hash = hashIndex >= 0 ? path.slice(hashIndex) : '';
  const withoutHash = hashIndex >= 0 ? path.slice(0, hashIndex) : path;
  const [pathname, search = ''] = withoutHash.split('?');
  const params = new URLSearchParams(search);
  params.set(PUBLIC_SITE_VIEW_PARAM, PUBLIC_SITE_VIEW_VALUE);
  return `${pathname}?${params.toString()}${hash}`;
}
